(() => {
  const init = (root) => {
    if (root.dataset.scReady) return;
    root.dataset.scReady = '1';
    root.querySelectorAll('[data-sc-card]').forEach((card) => {
      const front = card.querySelector('[data-sc-face="front"]');
      const back = card.querySelector('[data-sc-face="back"]');
      if (!front || !back) return;
      const flips = card.querySelectorAll('[data-sc-flip]');
      const set = (flipped) => {
        card.classList.toggle('is-flipped', flipped);
        front.inert = flipped;
        back.inert = !flipped;
        front.setAttribute('aria-hidden', String(flipped));
        back.setAttribute('aria-hidden', String(!flipped));
        flips.forEach((b) => b.setAttribute('aria-expanded', String(flipped)));
        const target = (flipped ? back : front).querySelector('[data-sc-flip]');
        if (target) target.focus({ preventScroll: true });
      };
      flips.forEach((b) => b.addEventListener('click', () => set(!card.classList.contains('is-flipped'))));
    });
    root.querySelectorAll('[data-sc-ctog]').forEach((tog) => {
      const card = tog.closest('[data-sc-card]');
      if (!card) return;
      tog.addEventListener('click', (e) => {
        const b = e.target.closest('[data-sc-colour]');
        if (!b || !tog.contains(b)) return;
        const val = b.getAttribute('data-sc-colour');
        tog.querySelectorAll('[data-sc-colour]').forEach((x) => {
          const on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', String(on));
        });
        card.querySelectorAll('[data-sc-cv]').forEach((el) => { el.hidden = el.getAttribute('data-sc-cv') !== val; });
        const url = b.getAttribute('data-url');
        if (url) card.querySelectorAll('[data-sc-link]').forEach((a) => a.setAttribute('href', url));
      });
    });
    const deck = root.querySelector('[data-sc-deck]');
    const bar = root.querySelector('[data-sc-bar]');
    const count = root.querySelector('[data-sc-count]');
    if (!deck || !bar || !count) return;
    const n = deck.querySelectorAll('[data-sc-card]').length;
    let raf = 0;
    const update = () => {
      raf = 0;
      const max = deck.scrollWidth - deck.clientWidth;
      const i = max > 0 ? Math.round((deck.scrollLeft / max) * (n - 1)) : 0;
      bar.style.transform = `translateX(${i * 100}%)`;
      count.textContent = `${i + 1} of ${n}`;
    };
    deck.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  };
  const boot = () => document.querySelectorAll('[data-sc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
